import {useMapContext} from "@luciad/ria-sample-common/hooks/useMapContext";
import {useToastContext} from "@luciad/ria-sample-common/hooks/useToast";
import React from "react";
import {addLayer} from "../DataFormatsUtil";
import {OSMDataLoader} from "../loaders/OSMDataLoader";
import {ConnectToURLPage} from "./ConnectToURLPage";

interface Props {
  onPrevious: () => void;
  onReset: () => void;
}

export const ConnectToOSMWizard = ({onPrevious, onReset}: Props) => {
  const {map} = useMapContext();
  const {showErrorToast} = useToastContext();

  const handleURLSubmit = (url: string) => {
    try {
      const layer = OSMDataLoader.createLayer(url);
      addLayer(map, layer).then(() => {
        onReset();
      }).catch((error) => {
        showErrorToast("Could not add OSM layer", error);
      });
    } catch (error) {
      showErrorToast("Could not create OSM layer", error);
    }
  };

  return (
      <ConnectToURLPage onSubmit={handleURLSubmit} onPrevious={onPrevious}/>
  )
}